import { TrackingProperties } from "store/config";

export const ACCOUNT_INFORMATION_ID_QUERY_STRING_PARAM = "Id";
export const NONCE_QUERY_STRING_PARAM = "Nonce";

export const requestPayTrackingProperties: TrackingProperties[] = [
  {
    propertyName: ACCOUNT_INFORMATION_ID_QUERY_STRING_PARAM,
    displayName: "ID",
    isCustomProperty: false,
    isInvoiceProperty: false,
    providedForValidation: false,
  },
  {
    propertyName: NONCE_QUERY_STRING_PARAM,
    displayName: "Nonce",
    isCustomProperty: true,
    isInvoiceProperty: false,
    providedForValidation: false,
  },
];
